<small *ngIf="help" id="{{ formId }}-help" class="text-gray-600">
  {{ help }}
</small>
